import { faCircleDollar } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, createStyles, makeStyles, Theme, Typography } from '@material-ui/core';
import React from 'react';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: 'flex',
            flexDirection: 'column'
        },
        body: {
            flex: 1,
            gap: 16,
            display: 'flex',
            padding: '96px 24px 64px',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            textAlign: 'center'
        },
        iconContainer: {
            width: 91,
            height: 91,
            display: 'flex',
            borderRadius: '50%',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#000000'
        },
        icon: {
            color: '#ffffff',
            fontSize: 36,
            lineHeight: 1
        },
        message: {
            fontFamily: 'YoungSerif',
            fontSize: 46,
            fontWeight: 600,
            lineHeight: '120%',
            letterSpacing: 0,
            color: '#C4B29E',
            textAlign: 'center'
        },
        description: {
            fontFamily: 'Poppins',
            fontSize: 15,
            fontWeight: 400,
            lineHeight: '140%',
            letterSpacing: 0,
            color: '#222222',
            textAlign: 'center'
        },
        [theme.breakpoints.down('sm')]: {
            body: {
                gap: 12,
                padding: '88px 24px 56px'
            },
            message: {
                width: 285,
                fontSize: 28,
                lineHeight: '120%'
            },
            description: {
                width: 314,
                fontSize: 18,
                lineHeight: '140%'
            }
        }
    })
);

const ClientTransactionsEmpty: React.FC = () => {
    const classes = useStyles();

    return (
        <Box className={classes.root}>
            <Box className={classes.body}>
                <Box className={classes.iconContainer}>
                    <FontAwesomeIcon
                        icon={faCircleDollar}
                        className={classes.icon}
                    />
                </Box>
                <Typography className={classes.message}>No Transactions Yet</Typography>
                <Typography className={classes.description}>This client no registered transactions.</Typography>
            </Box>
        </Box>
    );
};

export default ClientTransactionsEmpty;
